import api from 'services/api';
import get from 'lodash/get';
import set from 'lodash/set';
import { checkId } from 'services/common';
import { GET, POST, DELETE, apiKeysRoutes } from 'constants/api';
import { API_KEYS_TOKEN_KEY } from 'constants/common';

const checkApiKeyId = apiKeyId => {
  checkId(apiKeyId, 'ApiKey id is missing');
};

const checkProjectId = projectId => {
  checkId(projectId, 'Project id is missing');
};

export const createApiKey = ({
  projectId,
  name,
  template_types,
  can_unsubscribe,
}) => {
  checkProjectId(projectId);
  return api({
    method: POST,
    url: apiKeysRoutes.CREATE_API_KEY,
    data: { name, project_id: projectId, template_types, can_unsubscribe },
  });
};

export const getApiKeys = () =>
  api({
    method: GET,
    url: apiKeysRoutes.GET_API_KEYS,
  });

export const deleteApiKey = apiKeyId => {
  checkApiKeyId(apiKeyId);
  return api({
    method: DELETE,
    url: `${apiKeysRoutes.DELETE_API_KEY}${apiKeyId}`,
    id: apiKeyId,
  });
};

const getStoredKeys = () => {
  const apiKeysString = localStorage.getItem(API_KEYS_TOKEN_KEY) || '{}';
  let apiKeys;
  try {
    apiKeys = JSON.parse(apiKeysString);
  } catch (error) {
    apiKeys = {};
  }
  return apiKeys;
};

const setStoredKeys = apiKeys => {
  let apiKeysString;
  try {
    apiKeysString = JSON.stringify(apiKeys);
  } catch (error) {
    apiKeysString = '{}';
  }
  localStorage.setItem(API_KEYS_TOKEN_KEY, apiKeysString);
  return apiKeys;
};

export const getDefaultProjectApiKey = projectId => {
  const apiKeys = getStoredKeys();
  return get(apiKeys, `[${projectId}]`) || '';
};

export const setDefaultProjectApiKey = (projectId, apiKey) => {
  const apiKeys = getStoredKeys();
  set(apiKeys, `[${projectId}]`, apiKey);
  return setStoredKeys(apiKeys);
};
